
import { commonfunc } from '~/mixin/common'

export default {
  name: 'ProdOption',
  mixins: [commonfunc],
  props: {
    optCn: {
      type: String,
      default: ''
    },
    isSpbk: { // 장바구니에서 사용
      type: Boolean,
      default: false
    },
    randomColorRed: {
      type: Boolean,
      default: false
    }
  }
}
